import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../modules/shared/services/auth/auth.service';
/**
 * Guard for routes that should only be accessible when NOT authenticated
 * (e.g., login, register pages)
 */
@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate() // route: ActivatedRouteSnapshot,
  // state: RouterStateSnapshot
  : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService
      .isAuthenticated()
      .then((isAuthenticated) => {
        // LEA-257: keep verified deactivation UX on /authenticated, not login
        if (!isAuthenticated && this.authService.getBrokerAccessDeactivatedFlag()) {
          return this.router.createUrlTree(['/authenticated']);
        }
        if (!isAuthenticated) {
          return true;
        }
        // User is authenticated, redirect to app
        return this.router.createUrlTree(['/authenticated']);
      })
      .catch((error) => {
        console.error('[NoAuthGuard] error', error);
        // On error, allow access (fail open for auth pages)
        return true;
      });
  }
}
